// api/companyApi.ts
import { baseApi } from "./BaseApi";
import { Job } from "../types/jobTypes";
import { AgentJob } from "../types/agentTypes";

const agentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentJobs: builder.query<{ job: AgentJob }[], void>({
      query: () => `/agents/me/jobs`,
    }),
  }),
});

export const { useGetAgentJobsQuery, useLazyGetAgentJobsQuery } = agentApi;

export default agentApi;
